import React, {Component} from 'react';
import './App.css';
import PlayerList from './Components/PlayerList';
import BeerRules from './Components/BeerRules';
import TrainingAccordion from './Components/TrainingAccordion';
import UnknownPlayerModal from './Components/UnknownPlayerModal';
import ChooseLongTermDateModal from './Components/ChooseLongTermDateModal';
import {Button, Container, Grid, Header} from 'semantic-ui-react';
import LongTermDeregistrations from "./Components/LongTermDeregistrations";
import UnregisterRegularPlayerModal from "./Components/UnregisterRegularPlayerModal";
import RegisterRegularPlayerModal from "./Components/RegisterRegularPlayerModal";
import RegisterBoughtBeersModal from "./Components/RegisterBoughtBeersModal";
import ChangeTrainingTimeModal from "./Components/ChangeTrainingTimeModal";
import FAQ from "./Components/FAQ";
import {CancelTrainingModal} from "./Components/CancelTraningModal";
import PlayerStatsModal from "./Components/PlayerStatsModal";


class App extends Component {

    state = {
        longTerm: {
            choosing: false
        },
        unregistering: false,
        registering: false,
        registeringBeers: false,
        changingTrainingTime: false,
    };

    componentDidMount() {
        const agentId = localStorage.getItem('kampbart.cage.agentId');
        const agentName = localStorage.getItem('kampbart.cage.agentName');
        if (agentId) {
            this.setState({agent: {id: agentId, name: agentName}});
        }
        this.getData();
    };

    setCurrentAgent = agent => {
        localStorage.setItem('kampbart.cage.agentId', agent.id);
        localStorage.setItem('kampbart.cage.agentName', agent.name);
        this.setState({agent});
    };

    setSelectedPlayer = selectedPlayer => {
        this.setState({selectedPlayer});
    };

    setChoosingLongTerm = choosing =>
        this.setState({longTerm: {choosing}});

    setLongTermDate = date => {
        this.postEvent({
            type: 'LONG_TERM_DEREGISTER_PLAYER',
            agentId: this.state.agent.id,
            toDate: date
        });
        this.setChoosingLongTerm(false);
    };

    removeLongTermDate = () => {
        this.postEvent({
            type: 'REMOVE_LONG_TERM_DEREGISTRATION',
            agentId: this.state.agent.id
        });
    };

    unregisterRegularPlayer = playerId => {
        this.postEvent({
            type: 'UNREGISTER_REGULAR_PLAYER',
            playerId
        });
        this.setState({unregistering: false})
    };

    registerRegularPlayer = name => {
        this.postEvent({
            type: 'REGISTER_REGULAR_PLAYER',
            name
        });
        this.setState({registering: false})
    };

    registerBoughtBeers = (playerId, boughtBeerCount, comment) => {
        this.postEvent({
            type: 'REGISTER_BOUGHT_BEERS',
            playerId,
            boughtBeerCount,
            comment,
        });
        this.setState({registeringBeers: false})
    };

    changeTrainingTime = (weekDay, hours, minutes) => {
        this.postEvent({
            type: 'CHANGE_TRAINING_TIME',
            weekDay,
            hours,
            minutes,
        });
        this.setState({changingTrainingTime: false})
    };

    cancelTraining = (trainingId) => {
        this.postEvent({
            type: 'CANCEL_TRAINING',
            cageTrainingId: trainingId,
        })
    };

    clearAgent = () => {
        this.setState({agent: null});
        localStorage.removeItem('kampbart.cage.agentId');
        localStorage.removeItem('kampbart.cage.agentName');
    };

    getData = () => {
        fetch('/api/', {credentials: 'same-origin'})
            .then(response => response.json())
            .then(data => this.setState({data}))
    };

    postEvent = body => {
        return fetch('/api/',
            {
                credentials: 'same-origin',
                method: 'post',
                headers: {
                    "Content-Type": "application/json; charset=utf-8"
                },
                body: JSON.stringify({
                    agentId: this.state.agent.id,
                    ...body
                })
            })
            .then(response => response.json())
            .then(data => this.setState({data}));
    };

    getCurrentAgentDeregistration = () =>
        this.state.data.longTermDeregistrations.find(d => d.playerId === this.state.agent.id);

    render() {
        return (
            <div className="App">
                {this.state.data && this.state.data.cageTrainings ?
                    <div>
                        {window.location.search.endsWith("dashboard") &&
                            <Container>
                                <Button onClick={() => this.setState({unregistering: true})}>
                                    Avregistrer fast spiller
                                </Button>
                                <Button onClick={() => this.setState({registering: true})}>
                                    Legg til fast spiller
                                </Button>
                                <Button onClick={() => this.setState({registeringBeers: true})}>
                                    Innfri øl
                                </Button>
                                <Button onClick={() => this.setState({changingTrainingTime: true})}>
                                    Endre treningstid
                                </Button>
                                <UnregisterRegularPlayerModal
                                    open={this.state.unregistering}
                                    players={this.state.data.players}
                                    unregisterRegularPlayer={this.unregisterRegularPlayer}
                                />
                                <RegisterRegularPlayerModal
                                    open={this.state.registering}
                                    registerRegularPlayer={this.registerRegularPlayer}
                                />
                                <RegisterBoughtBeersModal
                                    open={this.state.registeringBeers}
                                    players={this.state.data.players}
                                    registerBoughtBeers={this.registerBoughtBeers}
                                />
                                <ChangeTrainingTimeModal
                                    open={this.state.changingTrainingTime}
                                    changeTrainingTime={this.changeTrainingTime}
                                />
                            </Container>}
                        <Container>
                            <Header as='h1'
                                    textAlign='left'
                                    style={{
                                        marginTop: '1em',
                                    }}>
                                Kampbart Cageballadmin
                                {this.state.agent ?
                                    <Header.Subheader>
                                        Registrert som {this.state.agent.name} -&nbsp;
                                        <a role="button" onClick={this.clearAgent} style={{cursor: 'pointer'}}>Endre</a>
                                        {this.state.agent.id !== "guest" ?
                                            <span>&nbsp;-&nbsp;
                                                {this.getCurrentAgentDeregistration() && this.getCurrentAgentDeregistration().deregisteredToDate ?
                                                    <a role="button" onClick={() => this.removeLongTermDate()}
                                                       style={{cursor: 'pointer'}}>
                                                        Fjern langtidsavmelding
                                                    </a>
                                                    :
                                                    <a role="button" onClick={() => this.setChoosingLongTerm(true)}
                                                       style={{cursor: 'pointer'}}>
                                                        Langtidsavmelding
                                                    </a>
                                                }
                                    </span> : null
                                        }
                                    </Header.Subheader> : null}
                            </Header>
                            <Grid stackable textAlign='left'>
                                <Grid.Row columns={2}>
                                    <Grid.Column width={10}>
                                        <LongTermDeregistrations
                                            deregistratons={this.state.data.longTermDeregistrations}/>
                                        <TrainingAccordion
                                            cageTrainings={this.state.data.cageTrainings}
                                            postEvent={this.postEvent}
                                            onCancel={(trainingId) => this.setState({cancelling: trainingId})}
                                        />
                                    </Grid.Column>
                                    <Grid.Column width={6}>
                                        <PlayerList
                                            heading="Faste spillere"
                                            players={this.state.data.players.filter(p => p.regular)}
                                            onSelect={this.setSelectedPlayer}
                                        />
                                        {this.state.data.players.filter(p => !p.regular).length
                                            ? <PlayerList
                                                heading="Andre spillere"
                                                players={this.state.data.players.filter(p => !p.regular)}
                                                onSelect={this.setSelectedPlayer}
                                            />
                                            : null}
                                        <BeerRules/>
                                        <FAQ/>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            <UnknownPlayerModal
                                open={!this.state.agent}
                                players={this.state.data.players}
                                setCurrentAgent={this.setCurrentAgent}
                            />
                            <PlayerStatsModal
                                player={this.state.selectedPlayer}
                                close={() => this.setSelectedPlayer(undefined)}
                            />
                            <ChooseLongTermDateModal
                                open={this.state.longTerm.choosing}
                                setLongTermDate={this.setLongTermDate}
                            />
                            <CancelTrainingModal
                                open={!!this.state.cancelling}
                                onSuccess={() => {
                                    this.cancelTraining(this.state.cancelling)
                                    this.setState({cancelling: undefined})
                                }}
                                onCancel={() => {
                                    this.setState({cancelling: undefined})
                                }}
                            />
                        </Container></div> : <p>Loading</p>
                }
            </div>
        );
    }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js